"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleSheetNames = exports.GoogleSheetNamesEnum = void 0;
const zod_1 = require("zod");
exports.GoogleSheetNamesEnum = zod_1.z.enum([
    "AccountsPayable",
    "Appointments",
    "Clients",
    "Invoices",
    "Members",
    "Packages",
    "Rates",
]);
exports.GoogleSheetNames = Object.values(exports.GoogleSheetNamesEnum.Values);
//# sourceMappingURL=google-sheet-schema.js.map